import React from "react";

const About = () => {
    return (
        <div>
            <h2>Sobre Nós</h2>
            <p>Este é um site criado com React para exibir informações.</p>
        </div>
    );
};

export default About;
